import React from 'react';
import { CadPreview } from 'libs/connection/cells';
import { Box, Icon, Paragraph } from 'components';
import { modalStore } from 'apps/modals/app';
import { ProductQuoteDetails } from '../ProductQuoteDetails';

export const ProductQuotePreviewCell = (productQuote: any) => {
  const { file } = productQuote.for.build;

  return <div style={{ height: '42px' }}>{CadPreview(file)}</div>;
};

export const ProductQuoteBuildDetailsCell = (productQuote: any) => {
  const {
    build: buildFor,
    quantity: forQuantity,
    leadTime: forLeadTime,
  } = productQuote.for;
  const {
    build: buildFrom,
    quantity: fromQuantity,
    leadTime: fromLeadTime,
  } = productQuote.from.jobSpec;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Paragraph>
        {buildFor.process.name}, {buildFor.material.name}
      </Paragraph>
      <Box
        ml={2}
        sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
      >
        <Icon
          name='info'
          onClick={(event: React.MouseEvent) => {
            event.stopPropagation();
            modalStore.SetModalComponent(ProductQuoteDetails, {
              buildFor,
              buildFrom,
              forQuantity,
              fromQuantity,
              forLeadTime,
              fromLeadTime,
            });
          }}
        />
      </Box>
    </Box>
  );
};
